import http from 'util/http'

/** 获取专题栏下面的分类 */
export function getCategory() {
  return http.get('/newxyrj/public/article/buddhisttopic/category', {
    to_show: 2,
  })
}
/**
 * 根据分类获取专题列表
 * @param {number} id 分类ID
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 * @param {number} sort 排序
 */
export function getList(
  id: number,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
  sort?: number,
) {
  return http.get('/newxyrj/public/topic/list', {
    category_id: id,
    pageindex,
    pagesize,
    sort,
  })
}

/**
 * 获取专题详情
 * @param {number} id 分类ID
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 */
export function getDetail(
  id,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
) {
  return http.get('/newxyrj/public/article/topic/id', {
    topic_id: id,
    pageindex,
    pagesize,
  })
}
